import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const MenuListSideOverlay = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: ${getBaseTheme().colors.area.default.backgroundColor};
    position: fixed;
    top: 0;
    left: 0;
    transition: transform 370ms ease-in-out;
    z-index: 3;
    transform: ${props =>
        props.openMenu ? 'translate3d(0vw, 0, 0)' : 'translate3d(-300vw, 0, 0)'};
    .menuList-container {
        height: 100vh;
        overflow: hidden scroll;
        padding: 0 ${getBaseTheme().spaces.default.xs};
    }
`;

export const MenuList = styled.ul`
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    padding-bottom: ${getBaseTheme().spaces.default.xs};
`;
